import React from "react";

export const TextInput = ({ id, label, type, placeholder, name = "", onChange = () => {} }) => (
  <>
    <label htmlFor={id} className="form-label">
      {label}
    </label>
    <input type={type || "text"} id={id} className="form-control" name={name} onChange={onChange} placeholder={placeholder || ""} />
  </>
);

export const NumberInput = ({ id, label, placeholder, name = "", onChange = () => {} }) => (
  <>
    <label htmlFor={id} className="form-label">
      {label}
    </label>
    <input type="number" id={id} className="form-control" name={name} onChange={onChange} placeholder={placeholder || ""} />
  </>
);

export const IconInput = ({ id, label, placeholder, icon, name = "", onChange = () => {} }) => (
  <>
    <label htmlFor={id} className="form-label">
      {label}
    </label>
    <div className="input-group">
      <span className="input-group-text fs-20">
        <iconify-icon icon={`solar:${icon}`} className="align-middle"></iconify-icon>
      </span>
      <input type="number" id={id} className="form-control" name={name} onChange={onChange} placeholder={placeholder || ""} />
    </div>
  </>
);

export const SelectInput = ({
  id,
  name,
  label,
  value,
  onChange,
  options = [],
  placeholder, // optional placeholder shown as disabled option
  multiple = false, // support multiple selects
  className = "form-control",
  ...rest
}) => {
  return (
    <>
      {label && (
        <label htmlFor={id || name} className="form-label">
          {label}
        </label>
      )}

      <select id={id || name} name={name} className={className} value={value === undefined || value === null ? (multiple ? [] : "") : value} onChange={onChange} multiple={multiple} {...rest}>
        {placeholder && !multiple && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}

        {options.map((option, idx) =>
          option.group ? (
            <optgroup key={`group-${idx}`} label={option.label}>
              {option.group.map((opt, i) => (
                <option key={`group-${idx}-opt-${i}`} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </optgroup>
          ) : (
            <option key={`opt-${idx}`} value={option.value}>
              {option.label}
            </option>
          )
        )}
      </select>
    </>
  );
};

export const RadioGroup = (props) => {
  const { children, ...inputProps } = props;

  return (
    <>
      <label className="form-label">{children}</label>
      <br />
      <div className="form-check form-check-inline">
        <input className="form-check-input" type="radio" id={`${props.name}-yes`} {...inputProps} value="yes" />
        <label className="form-check-label" htmlFor={`${props.name}-yes`}>
          Yes
        </label>
      </div>

      <div className="form-check form-check-inline">
        <input className="form-check-input" type="radio" id={`${props.name}-no`} {...inputProps} value="no" />
        <label className="form-check-label" htmlFor={`${props.name}-no`}>
          No
        </label>
      </div>
    </>
  );
};
